import { render, staticRenderFns } from "./Veo31SeoContent.vue?vue&type=template&id=5b0ae585&scoped=true"
import script from "./Veo31SeoContent.vue?vue&type=script&lang=js"
export * from "./Veo31SeoContent.vue?vue&type=script&lang=js"
import style0 from "./Veo31SeoContent.vue?vue&type=style&index=0&id=5b0ae585&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ae585",
  null
  
)

export default component.exports